import { createFormatter } from '@cof/fs-currency-field-core-beta';
export const setCustomValidity = {
    attribute: 'error-message',
    key: 'customError',
    message(instance) {
        return instance.errorMessage || 'invalid input';
    },
    isValid(instance) {
        const attrValue = instance.getAttribute('error-message');
        if (!instance.hasAttribute('error-message')) {
            return true;
        }
        if (attrValue.length === 0) {
            return true;
        }
        return false;
    }
};
/** Validates the currency input against the field's maximum allowable value */
export const maxValidatorCurrency = {
    attribute: 'max',
    key: 'rangeOverflow',
    message(instance) {
        const format = createFormatter(instance.managerConfig);
        return (instance.rangeOverflowMessage ||
            `Please enter a value less than the maximum of ${format(instance.max.toString())}`);
    },
    isValid(instance) {
        // manager is not defined, field is valid
        if (!instance.manager) {
            return true;
        }
        if (!instance.hasAttribute('max')) {
            return true;
        }
        // if max is not a number or undefined, field is valid
        if (isNaN(instance.max)) {
            console.error(`${instance.localName}: max needs to be a valid number`);
            return true;
        }
        // if unmaskedValue is undefined or string length is 0, field is value
        // if required is set to true that validation message should be triggered
        if (instance.unmaskedValue === undefined || instance.unmaskedValue.length === 0) {
            return true;
        }
        return +instance.unmaskedValue <= instance.max;
    }
};
/** Validates the currency input against the field's minimum allowable value */
export const minValidatorCurrency = {
    attribute: 'min',
    key: 'rangeUnderflow',
    message(instance) {
        const format = createFormatter(instance.managerConfig);
        return (instance.rangeUnderflowMessage ||
            `Please enter a value greater than the minimum of ${format(instance.min.toString())}`);
    },
    isValid(instance) {
        // manager is not defined, field is valid
        if (!instance.manager) {
            return true;
        }
        if (!instance.hasAttribute('min')) {
            return true;
        }
        // if min is not a number or undefined, field is valid
        if (isNaN(instance.min)) {
            console.error(`${instance.localName}: min needs to be a valid number`);
            return true;
        }
        // if unmaskedValue is undefined or string length is 0, field is value
        // if required is set to true that validation message should be triggered
        if (instance.unmaskedValue === undefined || instance.unmaskedValue.length === 0) {
            return true;
        }
        return +instance.unmaskedValue >= instance.min;
    }
};
//# sourceMappingURL=currency-validators.js.map